export const NETWORKS = [
  'ethereum',
  'optimism',
  'base',
  'polygon',
  'arbitrum',
  'scroll'
];
